import AOS from '@netc/aos';
import whenDomReady from 'when-dom-ready';

whenDomReady().then(() => {
  const settings = {
    animationAttibute: 'data-anim',
    thresholdAttribute: 'data-anim-threshold',
    reverseAttribute: 'data-anim-reverse',
  };

  // eslint-disable-next-line no-new
  new AOS(settings);
});
